module.exports = __webpack_public_path__ + "static/media/coupon.6f2a33e9.svg";